import { API_BASE, ASSET_VERSION } from '../config';

// Where the world's own 3D content lives. A PRIVATE GCS bucket — nothing here is
// fetched from storage.googleapis.com directly.
export const WORLD_MODELS_BUCKET = 'hypetunes_world_models';

// assetUrl — resolve a model reference to something the browser can load.
//
//   '/models/venues/metro.glb'   a file in public/, served with the app
//   'venues/metro.glb'           an object in the world-models bucket
//   'https://…'                  already absolute, left alone
//
// BOTH FORMS ON PURPOSE, because the move off the app deploy happens one asset
// at a time. A reference that starts with "/" is local; anything else is a
// bucket object name. Nothing has to move all at once, and nothing breaks while
// half of it has.
//
// Bucket objects go through the API's asset proxy rather than a signed GCS URL,
// and the reason is caching. A signed URL carries its signature and expiry IN
// the URL, so every session gets a different one — a different cache entry, and
// a 10MB venue re-downloaded on every visit. That would quietly undo
// MeshInterior's load-on-entry/free-on-exit design, which only works because
// coming back is a cache hit. The proxy URL is stable (bucket + name + version),
// so the browser can actually keep it, while the bucket stays private and the
// signing stays server-side.
export function assetUrl(ref) {
  if (!ref) return ref;
  if (/^https?:\/\//i.test(ref)) return ref;
  if (ref.startsWith('/')) return `${ref}${ref.includes('?') ? '&' : '?'}v=${ASSET_VERSION}`;
  return `${API_BASE}/api/assets/file?bucket=${encodeURIComponent(WORLD_MODELS_BUCKET)}`
    + `&name=${encodeURIComponent(ref)}&v=${ASSET_VERSION}`;
}

// Route a GCS asset (image or video) through the API proxy so WebGL can sample
// it — textures and VideoTextures are CORS-gated and the GCS buckets don't send
// Access-Control-Allow-Origin. Handles gs:// and signed storage.googleapis.com
// URLs (the signature query is dropped; the proxy re-signs by bucket+name).
// Anything else passes through untouched.
export function proxied(url) {
  if (!url) return url;
  try {
    if (url.startsWith('gs://')) {
      const rest = url.slice(5);
      const i = rest.indexOf('/');
      return `${API_BASE}/api/assets/file?bucket=${encodeURIComponent(rest.slice(0, i))}&name=${encodeURIComponent(rest.slice(i + 1))}`;
    }
    const u = new URL(url);
    if (u.hostname === 'storage.googleapis.com') {
      const parts = u.pathname.replace(/^\//, '').split('/');
      const bucket = parts.shift();
      const name = parts.map(decodeURIComponent).join('/');
      return `${API_BASE}/api/assets/file?bucket=${encodeURIComponent(bucket)}&name=${encodeURIComponent(name)}`;
    }
  } catch { /* passthrough */ }
  return url;
}
